export default "__VITE_ASSET__H7XiyKUB__"